import { render, staticRenderFns } from "./tiptap.vue?vue&type=template&id=470feff2&scoped=true"
import script from "./tiptap.ts?vue&type=script&lang=js&external"
export * from "./tiptap.ts?vue&type=script&lang=js&external"
import style0 from "./tiptap.vue?vue&type=style&index=0&id=470feff2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470feff2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VRow})
